import type { HeadingLevel } from "..";

export const DEFAULT_HEADING_LEVEL = 2 as const satisfies HeadingLevel;
